const newsInitState = {
    newsData: {},
    newsDetailsData: {}
};

export default newsInitState;
